// API timestamps are UTC when no offset is supplied; editing always uses Madrid.
export function eventInstant(value) {
  if (!value) return null;
  const text = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? value : `${value}Z`;
  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
}
export function madridParts(date) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date).map(p => [p.type, p.value]));
  return {date: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour}:${parts.minute}`};
}
export function validEventDate(value) {
  return /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0,10) === value;
}
export function candidateEdit(candidate) {
  const start = eventInstant(candidate.start_datetime);
  const local = start ? madridParts(start) : null;
  return {title: candidate.title || '', performer: candidate.performer || '',
    event_date: local?.date || candidate.resolved_event_date || '', start_time: local?.time || '',
    time_unknown: !candidate.start_datetime, event_type: candidate.event_type || 'other', price_text: candidate.price_text || ''};
}
export function correctionErrors(form) {
  return {...(!validEventDate(form.event_date) ? {event_date: 'Enter the verified event date.'} : {}),
    ...(!form.time_unknown && !/^([01]\d|2[0-3]):[0-5]\d$/.test(form.start_time || '')
      ? {start_time: 'Enter a valid time as HH:MM (Europe/Madrid), or select Time not supplied only if the source gives no time.'} : {})};
}
export function savedEligibility(saved, now = new Date()) {
  const start = eventInstant(saved.start_datetime), end = eventInstant(saved.end_datetime);
  const date = start ? madridParts(start).date : saved.resolved_event_date;
  const dateKnown = validEventDate(date) && (!saved.start_datetime || !!start);
  const reasons = [];
  if (!dateKnown) reasons.push('Date needed: verify the event date and any invalid start time.');
  if (!saved.venue_id) reasons.push('The canonical venue must be linked.');
  if (saved.supplied_event_review?.publication_block_reason) reasons.push(saved.supplied_event_review.publication_block_reason);
  else if (saved.warning_type) reasons.push(`Source warning: ${saved.warning_type.replace(/_/g, ' ')}`);
  if (saved.matching_event_id) reasons.push('A matching event already exists; resolve the possible duplicate.');
  if (dateKnown && date < madridParts(now).date) reasons.push('The event date is in the past in Europe/Madrid; the server will not publish it.');
  if (saved.end_datetime && (!end || !start || end <= start)) reasons.push('The saved end time is invalid or conflicts with the start; review the source and correct the occurrence.');
  else if (end && end <= now) reasons.push('The verified end time has passed; this event has ended.');
  if (!saved.evidence_count) reasons.push('Original source evidence is missing.');
  const startedWithoutEnd = !!start && start <= now && !saved.end_datetime;
  const reviewReasons = [
    ...(saved.requires_review || saved.recurrence_detected ? ['Check the extracted details against the original source.'] : []),
    ...(saved.confidence < 0.9 ? ['The extracted details have low confidence; check the source.'] : []),
    ...(!saved.evidence_count ? ['Saved evidence is missing; verify the original source.'] : []),
    ...(startedWithoutEnd ? ['The start time has passed and no end time is supplied. Verify the event is still relevant before approving; its duration is unknown.'] : []),
  ];
  return {dateKnown, reasons, reviewReasons, hardBlocked: reasons.length > 0, needsReview: reasons.length > 0 || reviewReasons.length > 0};
}
